/**
 * Component for main Returns settings page in the Dashboard.
 *
 * @component
 */

import {
  Alert,
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Tooltip,
  Typography,
} from 'antd';
import axios from 'axios';
import React from 'react';
import { Link } from 'react-router-dom';
import { PageButtonHeader } from '../../../../components/CustomHeader';
import {
  frequentlyUsedCountries,
  nonFrequentlyUsedCountries,
} from '../../../../constants/constants';
import { SubscriptionContext } from '../../../../contexts/SubscriptionContext';
import { createShopifyUrl } from '../../../../helpers/createShopifyUrl';
import ReturnCusomizeQuery from './components/ReturnCustomizeQuery';
import ReturnMultipleAddress from './components/ReturnMultipleAddress';
import ReturnNoteCusomize from './components/ReturnNoteCustomize';
import ReturnReasonDialog from './components/ReturnReasonDialog';
import ReturnTemplate from './components/ReturnTemplateDialog';
import { trackingVitally } from '../../../../helpers/vitally';
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';

export const FormItem = Form.Item;
const { TextArea } = Input;
const { Text } = Typography;
const { Option } = Select;

class Settings extends React.Component {
  static contextType = SubscriptionContext;

  constructor(props) {
    super(props);
    this.state = {
      returnReasons: undefined,
      shuffleReturnReasons: false,
      excludedProductTags: undefined,
      refundToCredit: true,
      refundToOriginal: true,
      refundToExchange: true,
      returnOptionAdvancedExchange: false,
      refundToCustom1: false,
      refundToCustom2: false,
      refundToCustom3: false,
      refundToCustom1Label: undefined,
      refundToCustom2Label: undefined,
      refundToCustom3Label: undefined,
      customOptionsCount: 0,
      returnTimeframe: 30,
      allowCustomDeliveryDate: true,
      returnAddress: undefined,
      returnPolicy: undefined,
      returnInstructions: undefined,
      autoAccept: false,
      methodLabelCreation: false,
      methodLabelManual: false,
      methodCustomerChoice: false,
      methodInStore: false,
      receiverName: undefined,
      receiverCompany: undefined,
      receiverStreet1: undefined,
      receiverStreet2: undefined,
      receiverCity: undefined,
      receiverState: undefined,
      receiverZip: undefined,
      receiverCountry: undefined,
      receiverPhone: undefined,
      receiverEmail: undefined,
      restockingFeeEnabled: undefined,
      restockingFeeValue: undefined,
      labelFeeEnabled: undefined,
      labelFeeValue: undefined,
      allowOrderUnfulfilled: false,
      allowOrderPaymentPending: false,
      allowOrderPaymentAuthorized: false,
      allowMultipleReturns: false,
      customerPhotoUploadEnabled: undefined,
      customerPhotoUploadRequired: undefined,
      customerPhotoUploadDescription: undefined,
      minimumPhoto: 0,
      maximumPhoto: 5,
      vendorList: undefined,
      showModal: false,
      ModalText: 'Content of the modal',
      visible: false,
      selectedStoreAddress: null,
      updateProps: false,
      restockingFeeType: 'fixed',
      restockingFeeIncludeTax: false,
      modalVisible: false,
      useGiftApiForStoreCredit: false,
      useDiscountCodeForStoreCredit: false,
      useStoreCredit: false,
      allScopesIncluded: undefined,
      storeCreditIncluded: undefined,
      shopifyPlanName: undefined,
      shopifyUrl: undefined,
      storeCreditShopifyUrl: undefined,
      enableHtmlEmailTemplates: undefined,
      migrateHtmlContent: undefined,
      returnOptionStoreWideExchange: false,
      updateReturnResolution: false,
      modalCustomize: false,
      modalCustomQuery: false,
      indexModalCustomQuery: null,
      additionalFields: [],
      enteredExcludeProductTags: '',
      trackingChange: {},
      upsEnabled: undefined,
      loading: true,
      enableConvenience: false,
      enableGiftReturns: false,
      enableReturnItemLimits: false,
      returnItemLimits: 0,
      enableReturnRequestLimits: false,
      returnRequestLimits: 0,
      enableReturnTimeframeLimits: false,
      returnLimitsPerTimeframe: 0,
      returnLimitTimeframe: 30,
      excludeReturnLimit: [],
    };
  }
  formRef = React.createRef();

  handleAddCustomOption = () => {
    if (this.state.customOptionsCount < 3) {
      this.setState((prevState) => ({
        customOptionsCount: prevState.customOptionsCount + 1,
      }));
    }
  };

  handleCustomOptionChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  renderCustomOptions = () => {
    const customOptions = [];

    for (let i = 1; i <= 3; i++) {
      customOptions.push(
        <div key={i} className="flex-row flex-row--noMargin u-width--100">
          <Form.Item
            name={`refundToCustom${i}`}
            valuePropName="checked"
            initialValue={this.state[`refundToCustom${i}`]}
            style={{ marginBottom: 10 }}
          >
            <Checkbox
              name={`refundToCustom${i}`}
              onChange={this.handleCustomOptionChange}
            >
              Custom option {i}
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={`refundToCustom${i}Label`}
            initialValue={this.state[`refundToCustom${i}Label`]}
          >
            <Input
              placeholder="Add text that is shown to the customer"
              name={`refundToCustom${i}Label`}
              onChange={this.handleCustomOptionChange}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </div>
      );
    }

    return customOptions;
  };

  showAddressModal = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };

  getReturnSettings = async () => {
    try {
      const response = await axios.get('/api/returnSettings');
      if (response.data == null) {
        return;
      }
      return response.data;
    } catch (err) {
      message.error('Error retrieving your return settings. Try again.', 5);
    }
  };
  async componentDidMount() {
    try {
      if (this.context.featureMultipleAddress) {
        this.setState({
          updateProps: true,
        });
      }

      const data = await Promise.all([
        this.getReturnSettings(),
        this.checkScopesAndPlan(),
      ]);
      const access_scopes = data[1]?.access_scopes;
      await this.generateShopifyUrl(access_scopes);
      let customOptionsCount = 0;
      if (this.state.refundToCustom1 || this.state.refundToCustom1Label)
        customOptionsCount = 1;
      if (this.state.refundToCustom2 || this.state.refundToCustom2Label)
        customOptionsCount = 2;
      if (this.state.refundToCustom3 || this.state.refundToCustom3Label)
        customOptionsCount = 3;
      const customPhotoSetting = data[0]?.customPhotoSetting || {};
      this.setState({
        ...data[0],
        ...data[1],
        customOptionsCount,
        minimumPhoto: customPhotoSetting.minimumPhoto ?? 0,
        maximumPhoto: customPhotoSetting.maximumPhoto ?? 5,
        loading: false,
      });
    } catch (err) {
      this.setState({ loading: false });
      if (err?.response?.status !== 429) {
        message.error('Error retrieving your settings. Try again.', 5);
      }
    }
  }

  generateShopifyUrl = async (access_scopes) => {
    const shopifyUrl = await createShopifyUrl(
      '/dashboard/settings',
      access_scopes
    );
    this.setState({
      ...shopifyUrl,
    });
  };

  checkScopesAndPlan = async () => {
    try {
      const response = await axios.get('/api/returnSettings/scopes');
      if (response.data == null) {
        return;
      }
      return response.data;
    } catch (err) {
      message.error('Error retrieving access scopes and plan. Try again.', 5);
    }
  };

  showConfigureModal = (showModal = true) => {
    this.setState({
      showModal: showModal,
    });
  };

  showReturnModal = () => {
    this.setState({
      modalVisible: true,
    });
  };

  handleOk = () => {
    this.setState({
      modalVisible: false,
    });
  };

  handleCancel = () => {
    this.setState({
      modalVisible: false,
    });
  };

  //Handle open return template
  showTemplateModal = () => {
    this.setState({
      modalTemplate: true,
    });
  };

  handleCancelModalTemplate = () => {
    this.setState({
      modalTemplate: false,
    });
  };

  //Handle open note customize
  showCustomizeNoteModal = () => {
    this.setState({
      modalCustomize: true,
    });
  };

  handleModalCustomize = () => {
    this.setState({
      modalCustomize: false,
    });
  };

  handleCancelModalCustomize = () => {
    this.setState({
      modalCustomize: false,
    });
  };

  //Handle open customize query
  showCustomizeQueryModal = (position) => {
    this.setState({
      modalCustomQuery: true,
      indexModalCustomQuery: position === null ? null : position,
    });
  };

  handleCustomizeQueryModal = () => {
    this.setState({
      modalCustomQuery: false,
    });
  };

  handleCancelCustomizeQueryModal = () => {
    this.setState({
      modalCustomQuery: false,
    });
  };

  updateState = (newState) => {
    this.setState({
      ...newState,
    });
  };

  removeStringWhitespace = (strParam) => {
    if (strParam == null || strParam === '') {
      return null;
    }
    let strArray = strParam.split('\n');
    strArray = strArray.filter((str) => {
      str = str.trim();
      if (str != '') return true;
      return false;
    });
    return strArray.join('\n');
  };

  updateStoreAddress = async (id, values) => {
    try {
      const response = await axios.post(
        '/api/returnSettings/multipleAddress/update',
        {
          id,
          values,
        }
      );

      if (response.data.status === 'error') {
        return message.error(
          'Error, Unable to add store address, Please try again.',
          5
        );
      }
    } catch (err) {
      return message.error(
        'Error, Unable to update store address, Please try again.',
        5
      );
    }
  };

  handleSubmit = async () => {
    try {
      const values = await this.formRef.current.validateFields();

      this.trackingEvents(values);

      const excludedProductTags = this.removeStringWhitespace(
        values.excludedProductTags
      );
      const returnReasons = this.removeStringWhitespace(values.returnReasons);

      this.formRef.current.setFieldsValue({
        excludedProductTags,
        returnReasons,
      });

      if (this.context.featureMultipleAddress) {
        this.updateStoreAddress(this.state.selectedStoreAddress, values);
      }

      const response = await axios.post('/api/returnSettings/update', {
        ...values,
        excludedProductTags,
        returnReasons,
        excludeReturnLimit: this.state.excludeReturnLimit,
      });

      if (response.data.status === 'error') {
        return message.error(
          'Error updating your return settings. Please try again-----.',
          5
        );
      }
      if (response.data.status === 'error') {
        return message.error(
          'Error updating your return settings. Please try again-----.',
          5
        );
      }

      // Save custom photo settings
      await axios.post('/api/returnSettings/updateCustomPhotoUpload', {
        customPhotoSetting: {
          minimumPhoto: this.state.minimumPhoto,
          maximumPhoto: this.state.maximumPhoto,
        },
      });

      this.setState({
        ...response.data,
      });

      return message.success('Return settings successfully updated.', 5);
    } catch (err) {
      if (err.errorFields) {
        return message.error(
          'There is something wrong with the data you entered. Please check again.',
          5
        );
      }
    }
  };

  handleChange = (e) => {
    const target = e.target.id;
    const storeCreditChanged = target === 'useStoreCredit';
    const giftExchangeChanged = target === 'enableGiftReturns';
    const customerPhotoUploadChanged = target === 'customerPhotoUploadEnabled';
    const targetEnableCustomerUploadPhoto =
      target === 'customerPhotoUploadEnabled';
    const restockingFeeEnabled = target === 'restockingFeeEnabled';
    const labelFeeEnabled = target === 'labelFeeEnabled';
    const allowForUnpaidAndUnfulfilledOrders = [
      'allowOrderUnfulfilled',
      'allowOrderPaymentPending',
      'allowOrderPaymentAuthorized',
      'allowMultipleReturns',
    ].includes(target);
    this.setState({
      [target]: e.target.checked,
      trackingChange: {
        ...this.state.trackingChange,
        customerPhotoUploadEnabled: targetEnableCustomerUploadPhoto,
        restockingFeeEnabled,
        labelFeeEnabled,
        allowForUnpaidAndUnfulfilledOrders,
        storeCreditChanged,
        giftExchangeChanged,
        customerPhotoUploadChanged,
      },
    });
  };

  handleRestockingFeeType = (value) => {
    this.setState({
      restockingFeeType: value,
    });
  };

  handleMinPhotoChange = (value) => {
    if (value > this.state.maximumPhoto) {
      return message.error(
        'Minimum media must be less than or equal to maximum media',
        5
      );
    }
    this.setState({ minimumPhoto: value });
  };

  handleMaxPhotoChange = (value) => {
    if (value < this.state.minimumPhoto) {
      return message.error(
        'Maximum media must be greater than or equal to minimum media',
        5
      );
    }
    this.setState({ maximumPhoto: value });
  };

  getCountriesList = () => {
    let countriesList = [];
    frequentlyUsedCountries.forEach((country) => {
      countriesList.push(
        <Option
          value={country.code}
          key={`frequentlyUsedCountries${country.code}`}
        >
          {country.name}
        </Option>
      );
    });

    const disabledoption = (
      <Option value="disabled" key={'disabled'} disabled={true}>
        ---------
      </Option>
    );
    countriesList.push(disabledoption);
    nonFrequentlyUsedCountries.forEach((country) => {
      countriesList.push(
        <Option
          value={country.code}
          key={`nonFrequentlyUsedCountries${country.code}`}
        >
          {country.name}
        </Option>
      );
    });
    return countriesList;
  };

  handleStateValidator = (rule, value, callback) => {
    try {
      const receiverCountry =
        this.formRef.current.getFieldValue('receiverCountry') || '';
      if (!value && receiverCountry === 'US') {
        callback('This field is required for United States');
      } else {
        callback();
      }
    } catch (err) {
      callback(err);
    }
  };

  handleChangeMultipleAddress = (id, storeAddresses) => {
    this.setState({
      selectedStoreAddress: id,
    });

    const storeAddress = storeAddresses.filter((e) => {
      return e.id === id;
    });
    storeAddress.map((address) => {
      this.formRef.current.setFieldsValue({
        receiverName: address.fullName,
        receiverCompany: address.company,
        receiverStreet1: address.streetAddress,
        receiverStreet2: address.optional,
        receiverCountry: address.country,
        receiverCity: address.city,
        receiverState: address.state,
        receiverZip: address.zipCode,
        receiverEmail: address.email,
        receiverPhone: address.phone,
      });
    });
  };

  migrateHtmlContent = async () => {
    try {
      const response = await axios.post('/api/returnSettings/migrateData');
      if (response.status != 200) {
        return message.error(
          'Error, Unable to migrate html data, Please try again.',
          5
        );
      }
      this.setState({
        migrateHtmlContent: true,
      });
      return message.success('Data migrated successfully.', 5);
    } catch (err) {
      return message.error(
        'Error, Unable to migrate html data, Please try again.',
        5
      );
    }
  };

  onChangeEnteredExcludeProductTags = (e) => {
    this.setState({ enteredExcludeProductTags: e.target.value });
  };

  trackingEvents = (values) => {
    if (!values) returntrackingVitally('rr_returnsettings_changed');
    if (this.state?.trackingChange?.storeCreditChanged) {
      if (values.useStoreCredit) {
        trackingVitally('rr_storecredit_enable');
      } else {
        trackingVitally('rr_storecredit_disable');
      }
    }
    if (this.state?.trackingChange?.giftExchangeChanged) {
      if (values.enableGiftReturns) {
        trackingVitally('rr_giftexchange_enable');
      } else {
        trackingVitally('rr_giftexchange_disable');
      }
    }
    if (this.state?.trackingChange?.customerPhotoUploadChanged) {
      if (values.customerPhotoUploadEnabled) {
        trackingVitally('rr_photoupload_enable');
      } else {
        trackingVitally('rr_photoupload_disable');
      }
    }
  };

  changeListExcludeLimit = (resolution, checked) => {
    console.log(resolution, checked);
    if (checked) {
      this.setState({
        excludeReturnLimit: [...this.state.excludeReturnLimit, resolution],
      });
    } else {
      this.setState({
        excludeReturnLimit: this.state.excludeReturnLimit.filter(
          (item) => item !== resolution
        ),
      });
    }
  };

  render() {
    const excludeReturnLimit = this.state.excludeReturnLimit || [];
    const additionalFields = this.state.additionalFields || [];

    if (this.state.loading) {
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <div className="GlobalLoader GlobalLoader--md"></div>
        </div>
      );
    }
    return (
      <React.Fragment>
        <Form
          onFinish={this.handleSubmit}
          className="removeFormMargin"
          ref={this.formRef}
          initialValues={{
            enableFreeFirstReturn: this.state.enableFreeFirstReturn,
            freeFirstReturnLimit: this.state.freeFirstReturnLimit || 0,
            enableReturnItemLimits: this.state.enableReturnItemLimits,
            returnItemLimits: this.state.returnItemLimits || 0,
            enableReturnRequestLimits: this.state.enableReturnRequestLimits,
            returnRequestLimits: this.state.returnRequestLimits || 0,
            enableReturnTimeframeLimits: this.state.enableReturnTimeframeLimits,
            returnLimitsPerTimeframe: this.state.returnLimitsPerTimeframe || 0,
            returnLimitTimeframe: this.state.returnLimitTimeframe || 0,
          }}
        >
          <PageButtonHeader
            headingTitle={'Returns'}
            headingRightContent={
              <FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  data-intercom-target="top-save-button-configuration-returns"
                >
                  Save changes
                </Button>
              </FormItem>
            }
          ></PageButtonHeader>
          <Row
            type="flex"
            justify="start"
            align="top"
            style={{ marginBottom: 20 }}
          >
            <Col>
              <p>
                Set your return policy and define resolution options as well as
                details of the shipping process.
              </p>
            </Col>
          </Row>
          <div className="flex-row u-marginBottom--lg">
            <div className="flex-col-xxs-12">
              <Alert
                message="Important"
                description={
                  <span>
                    Set a rule for your business and staff to{' '}
                    <strong>NOT delete products</strong> from your Shopify Store
                    for orders that are still eligible for return. Deleting a
                    product will remove the associated product data from all
                    existing orders in your Shopify Store. Your customers will
                    not be able to start a return for orders with invalid
                    order-data. Shopify offers functionality to archive products
                    instead of deleting them.
                  </span>
                }
                type="info"
                showIcon
              />
            </div>
          </div>
          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="return-options-title-configuration-returns">
                Return options
              </h4>
              <span>
                Select possible resolution options that suit your business case.
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <h4
                  style={{ marginBottom: 20 }}
                  data-intercom-target="set-return-resolution-type-title-configuration-returns"
                >
                  Set return resolution type
                </h4>
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ gridRowGap: 20 }}
                >
                  <Form.Item
                    name="refundToCredit"
                    initialValue={this.state.refundToCredit}
                    valuePropName="checked"
                  >
                    <Checkbox
                      data-intercom-target="refund-to-credit-checkbox-configuration-returns"
                      onChange={(e) => this.handleChange(e)}
                    >
                      Refund to store credit
                    </Checkbox>
                  </Form.Item>
                  <FormItem
                    name="refundToOriginal"
                    initialValue={this.state.refundToOriginal}
                    valuePropName="checked"
                  >
                    <Checkbox
                      data-intercom-target="refund-to-original-checkbox-configuration-returns"
                      onChange={(e) => this.handleChange(e)}
                    >
                      Refund to original payment method
                    </Checkbox>
                  </FormItem>
                  {this.context.featureExchangeSelection ? (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <div className="u-marginBottom--sm">
                        <FormItem
                          name="refundToExchange"
                          initialValue={this.state.refundToExchange}
                          valuePropName="checked"
                        >
                          <Checkbox
                            data-intercom-target="refund-to-exchange-checkbox-configuration-returns"
                            onChange={(e) => this.handleChange(e)}
                          >
                            Variant Exchange
                          </Checkbox>
                        </FormItem>
                      </div>
                      <Button
                        data-intercom-target="configure-variant-exchange-button-configuration-returns"
                        href="/dashboard/settings/exchanges"
                      >
                        Configure Variant-Exchange
                      </Button>
                    </div>
                  ) : null}
                  {this.context.featureAdvancedExchanges ? (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <div className="u-marginBottom--sm">
                        <FormItem
                          name="returnOptionAdvancedExchange"
                          initialValue={this.state.returnOptionAdvancedExchange}
                          valuePropName="checked"
                        >
                          <Checkbox
                            data-intercom-target="advanced-exchange-checkbox-configuration-returns"
                            onChange={(e) => this.handleChange(e)}
                          >
                            Collection Exchange
                          </Checkbox>
                        </FormItem>
                      </div>
                      <Button
                        data-intercom-target="configure-advanced-exchange-button-configuration-returns"
                        href="/dashboard/settings/exchanges/advanced"
                      >
                        Configure Collection-Exchange
                      </Button>
                    </div>
                  ) : null}
                  {this.context.featureStoreWideExchange ? (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <div className="u-marginBottom--sm">
                        <FormItem
                          name="returnOptionStoreWideExchange"
                          initialValue={
                            this.state.returnOptionStoreWideExchange
                          }
                          valuePropName="checked"
                        >
                          <Checkbox
                            data-intercom-target="store-wide-exchange-checkbox-configuration-returns"
                            onChange={(e) => this.handleChange(e)}
                          >
                            Store-Wide Exchange
                          </Checkbox>
                        </FormItem>
                      </div>
                      <Button
                        data-intercom-target="configure-store-wide-exchange-button-configuration-returns"
                        href="/dashboard/settings/exchanges/storeWideExchange"
                      >
                        Configure Store-Wide-Exchange
                      </Button>
                    </div>
                  ) : null}
                  <div style={{ marginTop: '10px' }}>
                    <h4 data-intercom-target="custom-return-options-title-configuration-returns">
                      Set up custom return options
                    </h4>
                    <p>
                      If you want your customers to select a return type that
                      isn't currently available, you can add a custom return
                      option here. You can add up to three custom options.
                    </p>
                    <p className="u-marginBottom--none">
                      Please note that you can use the{' '}
                      <Link
                        data-intercom-target="advanced-rules-link-configuration-returns"
                        to="/dashboard/settings/rules"
                      >
                        advanced rules
                      </Link>{' '}
                      to customize the flow of the options you add.
                    </p>
                  </div>
                  {this.renderCustomOptions()}
                  <Form.Item>
                    {/* <Button // Disabled for now
                      ghost
                      onClick={this.handleAddCustomOption}
                      disabled={this.state.customOptionsCount === 3}
                    >
                      Add Custom Option
                    </Button> */}
                  </Form.Item>
                  {/* <FormItem>
                    {getFieldDecorator(
                      'refundToCustom1',
                      {}
                    )(
                      <Checkbox
                        checked={this.state.refundToCustom1}
                        onChange={(e) => this.handleChange(e)}
                      >
                        Custom Option
                      </Checkbox>
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator('refundToCustom1Label', {
                      initialValue: this.state.refundToCustom1Label,
                    })(
                      <Input
                        addonBefore="Text for customer"
                        placeholder="Add text that is shown to the customer"
                      />
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator(
                      'refundToCustom2',
                      {}
                    )(
                      <Checkbox
                        checked={this.state.refundToCustom2}
                        onChange={(e) => this.handleChange(e)}
                      >
                        Custom Option
                      </Checkbox>
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator('refundToCustom2Label', {
                      initialValue: this.state.refundToCustom2Label,
                    })(
                      <Input
                        addonBefore="Text for customer"
                        placeholder="Add text that is shown to the customer"
                      />
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator(
                      'refundToCustom3',
                      {}
                    )(
                      <Checkbox
                        checked={this.state.refundToCustom3}
                        onChange={(e) => this.handleChange(e)}
                      >
                        Custom Option
                      </Checkbox>
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator('refundToCustom3Label', {
                      initialValue: this.state.refundToCustom3Label,
                    })(
                      <Input
                        addonBefore="Text for customer"
                        placeholder="Add text that is shown to the customer"
                      />
                    )}
                  </FormItem> */}
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="gift-exchange-title-configuration-returns">
                Gift Exchange
              </h4>
              <span>
                Enable Gift Exchange will allow users to return products as a
                gift.
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ gridRowGap: 20 }}
                >
                  <FormItem
                    name="enableGiftReturns"
                    initialValue={this.state.enableGiftReturns}
                    valuePropName="checked"
                  >
                    <Checkbox
                      data-intercom-target="gift-exchange-checkbox-configuration-returns"
                      onChange={(e) => this.handleChange(e)}
                    >
                      Enable Gift Exchange
                    </Checkbox>
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          {this.context.featureUpdateResoultion && (
            <React.Fragment>
              <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                <div className="flex-col-md-3 flex-col-xxs-12">
                  <h4 data-intercom-target="enable-resolutionhub-title-configuration-returns">
                    Enable ResolutionHub
                  </h4>
                  <span>
                    Check this box if you want to be able to update the return
                    resolution of a product in a return. This can be done in the{' '}
                    <b>Manage</b> section.
                    <br />
                    <br />
                    <strong>IMPORTANT: </strong>only applicable for pending
                    returns.
                  </span>
                </div>
                <div className="flex-col-md-8 flex-col-xxs-12">
                  <div className="ContentPanel">
                    <div className="flex-row flex-row--noMargin">
                      <h4 data-intercom-target="enable-resolutionhub-panel-title-configuration-returns">
                        Enable ResolutionHub
                      </h4>
                      <FormItem
                        name="updateReturnResolution"
                        initialValue={this.state.updateReturnResolution}
                        valuePropName="checked"
                      >
                        <Checkbox
                          data-intercom-target="enable-resolutionhub-checkbox-configuration-returns"
                          onChange={(e) => this.handleChange(e)}
                        >
                          Enable to update the return resolution
                        </Checkbox>
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>
              <Divider></Divider>
            </React.Fragment>
          )}

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="return-reasons-title-configuration-returns">
                Return reasons
              </h4>
              <span>
                Enter as many reasons as you like. Now you can also add
                translation for reasons.
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div className="flex-row flex-row--noMargin">
                  <Button
                    ghost
                    onClick={this.showReturnModal}
                    data-intercom-target="manage-return-reasons-button-configuration-returns"
                  >
                    Manage Return Reasons
                  </Button>
                  {this.state.modalVisible ? (
                    <ReturnReasonDialog
                      visible={this.state.modalVisible}
                      onOk={this.handleOk}
                      onCancel={this.handleCancel}
                      featureMultilangReturnReasons={
                        this.context.featureMultilangReturnReasons
                      }
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="shuffle-return-reasons-title-configuration-returns">
                Shuffle return reasons
              </h4>
              <span>
                Randomize the order of return reasons for each item on the
                returns-portal to guard against possible selection bias from the
                customer.
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div className="flex-row flex-row--noMargin">
                  <h4 data-intercom-target="shuffle-return-reasons-panel-title-configuration-returns">
                    Shuffle return reasons
                  </h4>
                  <FormItem
                    name="shuffleReturnReasons"
                    initialValue={this.state.shuffleReturnReasons}
                    valuePropName="checked"
                  >
                    <Checkbox
                      onChange={(e) => this.handleChange(e)}
                      data-intercom-target="shuffle-return-reasons-checkbox-configuration-returns"
                    >
                      Enable to shuffle return reasons
                    </Checkbox>
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="customize-customer-journey-title-configuration-returns">
                Customize customer journey
              </h4>
              <span>
                Create custom queries to communicate with your customers. You
                can make the customer notes section optional or required. You
                can also add additional questions and create checkboxes or
                radio-buttons to get the information you need from your
                customers.
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div className="flex-row flex-row--noMargin">
                  <Col span={24}>
                    <h4 data-intercom-target="customize-notes-title-configuration-returns">
                      Customize notes
                    </h4>
                    <Row
                      className="u-marginBottom--md u-rowGap--sm"
                      type="flex"
                      justify="space-between"
                      align="middle"
                    >
                      <Col>
                        <p className="u-marginBottom--sm">
                          If you would like to edit customer notes, click the
                          Customize button.
                        </p>

                        {this.state.modalCustomize ? (
                          <ReturnNoteCusomize
                            visible={this.state.modalCustomize}
                            onOk={this.handleModalCustomize}
                            onCancel={this.handleCancelModalCustomize}
                          />
                        ) : null}

                        <Button
                          data-intercom-target="customize-notes-button-configuration-returns"
                          onClick={this.showCustomizeNoteModal}
                        >
                          Customize
                        </Button>
                      </Col>
                    </Row>

                    {additionalFields && additionalFields.length > 0 && (
                      <React.Fragment>
                        <h4 data-intercom-target="questions-title-configuration-returns">
                          Questions
                        </h4>
                        <Row
                          type="flex"
                          className="u-width--100 u-marginBottom--md u-rowGap--sm"
                        >
                          {additionalFields.map((item, index) => {
                            return (
                              <Row
                                key={index}
                                type="flex"
                                justify="space-between"
                                align="middle"
                                className="u-rowGap--sm u-width--100"
                              >
                                {this.state.modalCustomQuery &&
                                this.state.indexModalCustomQuery === index ? (
                                  <ReturnCusomizeQuery
                                    position={index}
                                    visible={this.state.modalCustomQuery}
                                    onOk={this.handleCustomizeQueryModal}
                                    onCancel={
                                      this.handleCancelCustomizeQueryModal
                                    }
                                    additionalFields={additionalFields}
                                  />
                                ) : null}
                                <Col
                                  style={{
                                    maxWidth: '100%',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Q{index + 1}: Type: {item.type}. Title:{' '}
                                  {item.title}
                                </Col>
                                <Col
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                  }}
                                >
                                  <Button
                                    className="custom-button"
                                    data-intercom-target={`edit-question-${index}-button-configuration-returns`}
                                    onClick={() => {
                                      this.showCustomizeQueryModal(index);
                                    }}
                                  >
                                    Edit
                                  </Button>
                                </Col>
                              </Row>
                            );
                          })}
                        </Row>
                      </React.Fragment>
                    )}
                    <h4 data-intercom-target="add-new-questions-title-configuration-returns">
                      Add new questions
                    </h4>
                    <Row
                      className="u-marginBottom--md u-rowGap--sm"
                      type="flex"
                      justify="space-between"
                      align="middle"
                    >
                      <Col>
                        <p className="u-marginBottom--sm">
                          If you would like to include multiple questions in
                          your customer's journey, click the Add button.
                        </p>

                        {this.state.modalCustomQuery &&
                        (this.state.indexModalCustomQuery === null ||
                          this.state.indexModalCustomQuery === undefined) ? (
                          <ReturnCusomizeQuery
                            visible={this.state.modalCustomQuery}
                            onOk={this.handleCustomizeQueryModal}
                            onCancel={this.handleCancelCustomizeQueryModal}
                            additionalFields={additionalFields}
                          />
                        ) : null}
                        <Row
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                          }}
                        >
                          <Button
                            ghost
                            data-intercom-target="add-question-button-configuration-returns"
                            onClick={() => {
                              this.showCustomizeQueryModal(null);
                            }}
                            disabled={additionalFields.length >= 5}
                          >
                            <span>Add</span>
                          </Button>
                        </Row>
                      </Col>
                    </Row>
                    <Row
                      span={24}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      {additionalFields.length}/5 questions already added
                    </Row>
                  </Col>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <Row
            type="flex"
            justify="space-around"
            align="middle"
            className="u-marginBottom--md"
          >
            <Col span={24}>
              <Alert
                data-intercom-target="return-labels-info-alert-configuration-returns"
                message="How to set up automated return labels?"
                description={
                  <span>
                    We cover the setup of automated return labels{' '}
                    <a
                      data-intercom-target="email-template-link-configuration-returns"
                      href="https://support.richreturns.io/en/articles/17693503-how-to-set-up-automated-return-labels?utm_source=configuration-returns"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      here in our Help Docs
                    </a>
                  </span>
                }
                type="info"
                showIcon
              />
            </Col>
          </Row>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="return-methods-title-configuration-returns">
                Return methods
              </h4>
              <span>Select at least one return method.</span>
              <span>
                (Return labels are optional) After you set up automated return
                labels with a supported carrier they will be sent out via email
                to the customer once the return has been approved. You can find
                the corresponding email templates here:{' '}
                <a
                  data-intercom-target="email-template-link-configuration-returns"
                  href="/dashboard/email"
                >
                  email template
                </a>
                .
              </span>
              <span>
                <strong> IMPORTANT: </strong> only enable <strong>one</strong>{' '}
                of the pre-paid label options (automatic or manual).
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ gridRowGap: 20 }}
                >
                  <div className="flex-row flex-row--noMargin u-width--100">
                    <h4 data-intercom-target="set-prepaid-label-type-title-configuration-returns">
                      Set pre-paid label type
                    </h4>
                    <FormItem
                      name="methodLabelCreation"
                      initialValue={this.state.methodLabelCreation}
                      valuePropName="checked"
                    >
                      <Checkbox
                        data-intercom-target="prepaid-label-automatic-checkbox-configuration-returns"
                        onChange={(e) => this.handleChange(e)}
                      >
                        <div className="flex-row flex-row--noMargin flex-middle-xxs u-columnGap--sm u-rowGap--sm">
                          Pre-Paid Return Label (automatic)
                          <Tooltip
                            data-intercom-target="prepaid-label-automatic-info-icon-configuration-returns"
                            title="This option uses our carrier integration to automatically generate the label. The label will be displayed directly to the customer in the returns portal (if you have the auto-approve option enabled), and you can automatically send the label and tracking link to the customer in the 'approved' email template (be sure to include the dynamic variables for label and tracking)."
                            placement="bottom"
                          >
                            <InfoCircleOutlined />
                          </Tooltip>
                        </div>
                      </Checkbox>
                    </FormItem>
                    <FormItem
                      name="methodLabelManual"
                      initialValue={this.state.methodLabelManual}
                      valuePropName="checked"
                      style={{ marginTop: '10px' }}
                    >
                      <Checkbox
                        data-intercom-target="prepaid-label-manual-checkbox-configuration-returns"
                        onChange={(e) => this.handleChange(e)}
                      >
                        <div className="flex-row flex-row--noMargin flex-middle-xxs u-columnGap--sm u-rowGap--sm">
                          Pre-Paid Return Label (manual)
                          <Tooltip
                            data-intercom-target="prepaid-label-manual-info-icon-configuration-returns"
                            title="With this option you have to manually send your label to the customer. In the 'Pending' email template you can tell the customer that you will send him/her the label via email after you have reviewed the return. Then send them the label via email manually."
                            placement="bottom"
                          >
                            <InfoCircleOutlined />
                          </Tooltip>
                        </div>
                      </Checkbox>
                    </FormItem>
                    {/* <div className="flex-row flex-row--noMargin u-rowGap--sm u-width--100">
                    </div> */}
                  </div>
                  <div className="flex-row flex-row--noMargin u-width--100">
                    <h4 data-intercom-target="set-customer-return-responsibility-title-configuration-returns">
                      Set customer return responsibility
                    </h4>
                    <FormItem
                      name="methodCustomerChoice"
                      initialValue={this.state.methodCustomerChoice}
                      valuePropName="checked"
                    >
                      <Checkbox
                        data-intercom-target="customer-return-responsibility-checkbox-configuration-returns"
                        onChange={(e) => this.handleChange(e)}
                      >
                        Customer is responsible for Return Shipping
                      </Checkbox>
                    </FormItem>
                  </div>
                  <div className="flex-row flex-row--noMargin u-width--100">
                    <h4 data-intercom-target="set-as-in-store-return-title-configuration-returns">
                      Set as in-store return
                    </h4>
                    <FormItem
                      name="methodInStore"
                      initialValue={this.state.methodInStore}
                      valuePropName="checked"
                    >
                      <Checkbox
                        data-intercom-target="in-store-return-checkbox-configuration-returns"
                        onChange={(e) => this.handleChange(e)}
                      >
                        In-Store Return
                      </Checkbox>
                    </FormItem>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <div className="flex-row flex-row--noMargin flex-middle-xxs u-rowGap--sm u-columnGap--sm">
                <h4
                  className="u-marginBottom--none"
                  data-intercom-target="return-timeframe-title-configuration-returns"
                >
                  Return timeframe (in days)
                </h4>
                <Tooltip
                  data-intercom-target="return-timeframe-tooltip-configuration-returns"
                  placement="top"
                  title="Ensure your store updates order fulfillment status correctly. If no 'delivered' event is found, we default to the last fulfillment update, so consider adding a few buffer days."
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </div>
              <span>
                How long should customers be able to return products after the
                order has been delivered?
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div className="flex-row flex-row--noMargin">
                  <h4 data-intercom-target="enter-duration-title-configuration-returns">
                    Enter duration (in days)
                  </h4>
                  <FormItem
                    name="returnTimeframe"
                    initialValue={this.state.returnTimeframe}
                    rules={[
                      {
                        required: true,
                        message:
                          'Please enter the timeframe for customers to make returns.',
                      },
                    ]}
                  >
                    <InputNumber
                      data-intercom-target="return-timeframe-input-configuration-returns"
                      min={0}
                      style={{ width: '100%' }}
                    />
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="auto-accept-title-configuration-returns">
                Automatically accept returns
              </h4>
              <span>
                Check this box if you want to automatically accept a return
                initiated by a customer. If you enabled sending an email to the
                customer under "Email settings" this will trigger the "Approved"
                Email if activated (and skip the "Pending" email).
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div className="flex-row flex-row--noMargin">
                  <h4 data-intercom-target="auto-accept-panel-title-configuration-returns">
                    Automatically accept returns
                  </h4>
                  <FormItem
                    name="autoAccept"
                    initialValue={this.state.autoAccept}
                    valuePropName="checked"
                  >
                    <Checkbox
                      data-intercom-target="auto-accept-checkbox-configuration-returns"
                      onChange={(e) => this.handleChange(e)}
                    >
                      Enable to automatically accept returns
                    </Checkbox>
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="excluded-product-tags-title-configuration-returns">
                Excluded product-tags (optional)
              </h4>
              <span>
                Exclude certain products from being eligible for return based on
                one or more product-tags that you set on your Shopify
                product-page. One product-tag per line (no comma in between).
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div className="flex-row flex-row--noMargin">
                  <h4 data-intercom-target="list-product-tags-title-configuration-returns">
                    List product tags below
                  </h4>
                  <FormItem
                    name="excludedProductTags"
                    initialValue={this.state.excludedProductTags}
                  >
                    <TextArea
                      data-intercom-target="excluded-product-tags-textarea-configuration-returns"
                      rows={6}
                      placeholder="Enter 1 product-tag per line (no comma in between)"
                      onChange={this.onChangeEnteredExcludeProductTags}
                    />
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <React.Fragment>
            <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
              <div className="flex-col-md-3 flex-col-xxs-12">
                <h4>Return Limits</h4>
                <span>Restrict the number of returns per order</span>
              </div>
              <div className="flex-col-md-8 flex-col-xxs-12">
                <div className="ContentPanel">
                  <div className="flex-row flex-row--noMargin">
                    <h4>Enable free first return feature</h4>
                    <FormItem
                      name="enableFreeFirstReturn"
                      valuePropName="checked"
                    >
                      <Checkbox
                        checked={this.state.enableFreeFirstReturn}
                        onChange={(e) => this.handleChange(e)}
                      >
                        Enable
                      </Checkbox>
                    </FormItem>
                  </div>
                  {this.state.enableFreeFirstReturn && (
                    <div
                      className="flex-row flex-row--noMargin"
                      style={{ paddingTop: '10px' }}
                    >
                      <p>Maximum free returns per order</p>
                      <FormItem name="freeFirstReturnLimit">
                        <InputNumber
                          min={0}
                          step={1}
                          style={{ width: '30%' }}
                          disabled={!this.state.enableFreeFirstReturn}
                          parser={(value) =>
                            Math.floor(Number(value.replace(/[^\d]/g, '')))
                          }
                        />
                      </FormItem>
                    </div>
                  )}

                  <div
                    className="flex-row flex-row--noMargin"
                    style={{ paddingTop: '10px' }}
                  >
                    <h4>
                      Limit number of items that can be returned per order
                    </h4>
                    <FormItem
                      name="enableReturnItemLimits"
                      valuePropName="checked"
                    >
                      <Checkbox
                        checked={this.state.enableReturnItemLimits}
                        onChange={(e) => this.handleChange(e)}
                      >
                        Enable
                      </Checkbox>
                    </FormItem>
                  </div>
                  {this.state.enableReturnItemLimits && (
                    <div
                      className="flex-row flex-row--noMargin"
                      style={{ paddingTop: '10px' }}
                    >
                      <p>
                        Maximum number of items that can be returned per order
                      </p>
                      <FormItem name="returnItemLimits">
                        <InputNumber
                          min={0}
                          step={1}
                          style={{ width: '30%' }}
                          disabled={!this.state.enableReturnItemLimits}
                          parser={(value) =>
                            Math.floor(Number(value.replace(/[^\d]/g, '')))
                          }
                        />
                      </FormItem>
                    </div>
                  )}

                  <div
                    className="flex-row flex-row--noMargin"
                    style={{ paddingTop: '10px' }}
                  >
                    <h4>Limit number of return request per order</h4>
                    <FormItem
                      name="enableReturnRequestLimits"
                      valuePropName="checked"
                    >
                      <Checkbox
                        checked={this.state.enableReturnRequestLimits}
                        onChange={(e) => this.handleChange(e)}
                      >
                        Enable
                      </Checkbox>
                    </FormItem>
                  </div>
                  {this.state.enableReturnRequestLimits && (
                    <div
                      className="flex-row flex-row--noMargin"
                      style={{ paddingTop: '10px' }}
                    >
                      <p>Maximum number of return request per order</p>
                      <FormItem name="returnRequestLimits">
                        <InputNumber
                          min={0}
                          step={1}
                          style={{ width: '30%' }}
                          disabled={!this.state.enableReturnRequestLimits}
                          parser={(value) =>
                            Math.floor(Number(value.replace(/[^\d]/g, '')))
                          }
                        />
                      </FormItem>
                    </div>
                  )}

                  <div
                    className="flex-row flex-row--noMargin"
                    style={{ paddingTop: '10px' }}
                  >
                    <h4>Limit return number per user</h4>
                    <FormItem
                      name="enableReturnTimeframeLimits"
                      valuePropName="checked"
                    >
                      <Checkbox
                        checked={this.state.enableReturnTimeframeLimits}
                        onChange={(e) => this.handleChange(e)}
                      >
                        Enable
                      </Checkbox>
                    </FormItem>
                  </div>
                  {this.state.enableReturnTimeframeLimits && (
                    <React.Fragment>
                      <div
                        className="flex-row flex-row--noMargin"
                        style={{ paddingTop: '10px' }}
                      >
                        <p>
                          Maximum number of return that can be returned per
                          timeframe
                        </p>
                        <FormItem name="returnLimitsPerTimeframe">
                          <InputNumber
                            min={0}
                            step={1}
                            style={{ width: '30%' }}
                            disabled={!this.state.enableReturnTimeframeLimits}
                            parser={(value) =>
                              Math.floor(Number(value.replace(/[^\d]/g, '')))
                            }
                          />
                        </FormItem>
                      </div>
                      <div
                        className="flex-row flex-row--noMargin"
                        style={{ paddingTop: '10px' }}
                      >
                        <p>Timeframe (days)</p>
                        <FormItem name="returnLimitTimeframe">
                          <InputNumber
                            min={0}
                            step={1}
                            style={{ width: '30%' }}
                            disabled={!this.state.enableReturnTimeframeLimits}
                            parser={(value) =>
                              Math.floor(Number(value.replace(/[^\d]/g, '')))
                            }
                          />
                        </FormItem>
                      </div>
                    </React.Fragment>
                  )}

                  {(this.state.enableReturnTimeframeLimits ||
                    this.state.enableReturnRequestLimits ||
                    this.state.enableReturnItemLimits) && (
                    <React.Fragment>
                      <div
                        className="flex-row flex-row--noMargin"
                        style={{
                          paddingTop: '10px',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <h4>Exclude resolution return limit</h4>
                        <div>
                          <Checkbox
                            checked={excludeReturnLimit.includes('storeCredit')}
                            onChange={(e) =>
                              this.changeListExcludeLimit(
                                'storeCredit',
                                e.target.checked
                              )
                            }
                          >
                            Store Credit
                          </Checkbox>
                          <Checkbox
                            checked={excludeReturnLimit.includes(
                              'originalPaymentMethod'
                            )}
                            onChange={(e) =>
                              this.changeListExcludeLimit(
                                'originalPaymentMethod',
                                e.target.checked
                              )
                            }
                            style={{ margin: '8px 0px' }}
                          >
                            Refund
                          </Checkbox>
                          <Checkbox
                            checked={excludeReturnLimit.includes(
                              'exchangeItem'
                            )}
                            onChange={(e) =>
                              this.changeListExcludeLimit(
                                'exchangeItem',
                                e.target.checked
                              )
                            }
                            style={{ margin: '8px 0px' }}
                          >
                            Exchange Product
                          </Checkbox>
                          <Checkbox
                            checked={excludeReturnLimit.includes(
                              'advancedExchange'
                            )}
                            onChange={(e) =>
                              this.changeListExcludeLimit(
                                'advancedExchange',
                                e.target.checked
                              )
                            }
                            style={{ margin: '8px 0px' }}
                          >
                            Collection Exchange
                          </Checkbox>
                          <Checkbox
                            checked={excludeReturnLimit.includes(
                              'storeWideExchange'
                            )}
                            onChange={(e) =>
                              this.changeListExcludeLimit(
                                'storeWideExchange',
                                e.target.checked
                              )
                            }
                            style={{ margin: '8px 0px' }}
                          >
                            Store-Wide Exchange
                          </Checkbox>
                          <Checkbox
                            checked={excludeReturnLimit.includes(
                              'refundToCustom1'
                            )}
                            onChange={(e) =>
                              this.changeListExcludeLimit(
                                'refundToCustom1',
                                e.target.checked
                              )
                            }
                            style={{ margin: '8px 0px' }}
                          >
                            Custom Option 1
                          </Checkbox>
                          <Checkbox
                            checked={excludeReturnLimit.includes(
                              'refundToCustom2'
                            )}
                            onChange={(e) =>
                              this.changeListExcludeLimit(
                                'refundToCustom2',
                                e.target.checked
                              )
                            }
                            style={{ margin: '8px 0px' }}
                          >
                            Custom Option 2
                          </Checkbox>
                          <Checkbox
                            checked={excludeReturnLimit.includes(
                              'refundToCustom3'
                            )}
                            onChange={(e) =>
                              this.changeListExcludeLimit(
                                'refundToCustom3',
                                e.target.checked
                              )
                            }
                            style={{ margin: '8px 0px' }}
                          >
                            Custom Option 3
                          </Checkbox>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
          <Divider></Divider>

          <React.Fragment>
            <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
              <div className="flex-col-md-3 flex-col-xxs-12">
                <h4 data-intercom-target="enable-convenience-template-title-configuration-returns">
                  Enable the Convenience Return Template
                </h4>
                <span>
                  Manage the convenience return template to make the return
                  process quicker and more convenient.
                </span>
              </div>
              <div className="flex-col-md-8 flex-col-xxs-12">
                <div className="ContentPanel">
                  <div className="flex-row flex-middle-xxs flex-start-xxs u-rowGap--sm">
                    <div className="flex-col-xxs-12">
                      <h4 data-intercom-target="enable-template-title-configuration-returns">
                        Enable template
                      </h4>
                      <FormItem
                        name="enableConvenience"
                        valuePropName="checked"
                        initialValue={this.state.enableConvenience}
                      >
                        <Checkbox
                          data-intercom-target="enable-template-checkbox-configuration-returns"
                          onChange={(e) => this.handleChange(e)}
                        >
                          Enable convenience return template
                        </Checkbox>
                      </FormItem>
                    </div>
                    <div className="flex-col-xxs-12">
                      <Button
                        data-intercom-target="configure-button-configuration-returns"
                        ghost
                        onClick={this.showTemplateModal}
                        disabled={!this.state.enableConvenience}
                      >
                        Configure
                      </Button>
                    </div>
                    {this.state.modalTemplate ? (
                      <ReturnTemplate
                        visible={this.state.modalTemplate}
                        onOk={this.handleOk}
                        onCancel={this.handleCancelModalTemplate}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="fees-title-configuration-returns">
                Fees
              </h4>
              <span>
                Any fees set here have to be deducted from the refund. If you
                want to charge customers during the returns process, you can use
                our Stripe Integration. Learn more{' '}
                <a
                  data-intercom-target="fees-details-link-configuration-returns"
                  href="https://support.richreturns.io/en/articles/17693481-can-customers-pay-for-their-own-label?utm_source=configuration-returns"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>
                .
              </span>
              {this.state.restockingFeeType === 'percentage' && (
                <div>
                  <span data-intercom-target="restocking-percentage-info-configuration-returns">
                    Enable checkbox if you want restocking percentage for total
                    amount include tax
                  </span>
                </div>
              )}
              <div>
                <span>
                  Restocking Fee: The restocking fee you set here will be
                  displayed to the customer during the returns process. This fee
                  will be deducted from the final refund amount.
                </span>
              </div>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ gridRowGap: 20 }}
                >
                  <div className="flex-row flex-row--noMargin u-width--100">
                    <h4 data-intercom-target="enable-restocking-fee-title-configuration-returns">
                      Enable restocking-fee
                    </h4>
                    <FormItem
                      name="restockingFeeEnabled"
                      valuePropName="checked"
                      initialValue={this.state.restockingFeeEnabled}
                    >
                      <Checkbox
                        data-intercom-target="restocking-fee-checkbox-configuration-returns"
                        onChange={(e) => this.handleChange(e)}
                      >
                        Enable restocking-fee
                      </Checkbox>
                    </FormItem>
                  </div>
                  <div className="flex-row flex-row--noMargin u-width--100">
                    <h4 data-intercom-target="set-fee-type-title-configuration-returns">
                      Set fee type
                    </h4>
                    <div className="flex-row flex-row--noMargin u-width--100 u-rowGap--sm">
                      <FormItem
                        name="restockingFeeType"
                        initialValue={this.state.restockingFeeType}
                      >
                        <Select
                          data-intercom-target="restocking-fee-type-select-configuration-returns"
                          disabled={!this.state.restockingFeeEnabled}
                          onChange={this.handleRestockingFeeType.bind(this)}
                        >
                          <Option value="percentage">Percentage</Option>
                          <Option value="fixed">Fixed Amount</Option>
                        </Select>
                      </FormItem>
                      {this.state.restockingFeeType === 'percentage' && (
                        <FormItem
                          name="restockingFeeIncludeTax"
                          valuePropName="checked"
                          initialValue={this.state.restockingFeeIncludeTax}
                        >
                          <Checkbox
                            data-intercom-target="restocking-fee-include-tax-checkbox-configuration-returns"
                            onChange={(e) => this.handleChange(e)}
                            disabled={!this.state.restockingFeeEnabled}
                          >
                            Enable tax based restocking-fee
                          </Checkbox>
                        </FormItem>
                      )}
                    </div>
                  </div>
                  <div className="flex-row flex-row--noMargin u-width--100">
                    <div
                      className="flex-row flex-row--noMargin u-width--100 u-rowGap--sm u-columnGap--sm flex-start-xxs flex-middle-xxs"
                      style={{ marginBottom: 8 }}
                    >
                      <h4 data-intercom-target="restocking-fee-title-configuration-returns">
                        {`Restocking-Fee ( in ${
                          this.state.restockingFeeType === 'fixed'
                            ? " your store's currency"
                            : ' percentage'
                        } )`}
                      </h4>
                      {!this.state.methodCustomerPaidLabel && (
                        <Tooltip
                          data-intercom-target="restocking-fee-info-icon-configuration-returns"
                          title="Set a label fee to cover prepaid shipping label costs (only applies if the prepaid-label option is enabled). The fee is deducted from the refund. Use only numbers (e.g., 4.50). Do not use commas or include the currency."
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      )}
                    </div>
                    <FormItem
                      name="restockingFeeValue"
                      initialValue={this.state.restockingFeeValue}
                    >
                      {this.state.restockingFeeType === 'fixed' ? (
                        <InputNumber
                          data-intercom-target="restocking-fee-input-configuration-returns"
                          disabled={!this.state.restockingFeeEnabled}
                          min={0}
                          step={0.1}
                          style={{ width: '100%' }}
                        />
                      ) : (
                        <InputNumber
                          data-intercom-target="restocking-fee-input-configuration-returns"
                          disabled={!this.state.restockingFeeEnabled}
                          min={0}
                          max={100}
                          step={0.1}
                          style={{ width: '100%' }}
                        />
                      )}
                    </FormItem>
                  </div>
                  {!this.state.methodCustomerPaidLabel && (
                    <div className="flex-row flex-row--noMargin u-width--100">
                      <div
                        className="flex-row flex-row--noMargin u-width--100 u-rowGap--sm u-columnGap--sm flex-middle-xxs"
                        style={{ marginBottom: 8 }}
                      >
                        <h4
                          data-intercom-target="prepaid-label-fee-title-configuration-returns"
                          className="u-marginBottom--none"
                        >
                          Enable pre-paid label fee
                        </h4>
                        <Tooltip
                          data-intercom-target="prepaid-label-fee-info-icon-configuration-returns"
                          title="Enable this option. If you want customer select this option and will be responsible for the pre-paid label fee."
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      </div>
                      <div
                        className="flex-row flex-row--noMargin u-width--100"
                        style={{ gridRowGap: 20 }}
                      >
                        <FormItem
                          name="labelFeeEnabled"
                          valuePropName="checked"
                          initialValue={this.state.labelFeeEnabled}
                        >
                          <Checkbox
                            data-intercom-target="prepaid-label-fee-checkbox-configuration-returns"
                            onChange={(e) => this.handleChange(e)}
                          >
                            Enable prepaid label-fee
                          </Checkbox>
                        </FormItem>
                        <div className="flex-row flex-row--noMargin u-width--100">
                          <h4 data-intercom-target="label-fee-value-title-configuration-returns">
                            Set label fee value
                          </h4>
                          <FormItem
                            name="labelFeeValue"
                            initialValue={this.state.labelFeeValue}
                          >
                            <InputNumber
                              data-intercom-target="label-fee-value-input-configuration-returns"
                              min={0}
                              step={0.1}
                              style={{ width: '100%' }}
                              disabled={!this.state.labelFeeEnabled}
                            />
                          </FormItem>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="flex-row flex-row--noMargin u-width--100">
                    <h4 data-intercom-target="customer-responsibility-title-configuration-returns">
                      Set customer responsibility
                    </h4>
                    <FormItem
                      name="methodCustomerPaidLabel"
                      valuePropName="checked"
                      initialValue={this.state.methodCustomerPaidLabel}
                    >
                      <Checkbox
                        data-intercom-target="customer-responsibility-checkbox-configuration-returns"
                        onChange={(e) => this.handleChange(e)}
                      >
                        <div className="flex-row flex-row--noMargin u-rowGap--sm u-columnGap--sm flex-middle-xxs">
                          <div>Customer is responsible for label fee</div>
                          <Tooltip
                            data-intercom-target="customer-responsibility-info-icon-configuration-returns"
                            title="With this option customer will be responsible for the pre-paid label fees. If this option is enabled then functionality for the prepaid label and fixed label amount will be disabled."
                          >
                            <InfoCircleOutlined />
                          </Tooltip>
                        </div>
                      </Checkbox>
                    </FormItem>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="unpaid-unfulfilled-title-configuration-returns">
                Allow for Unpaid and Unfulfilled orders
              </h4>
              <span>
                Most merchants <strong>do not</strong> need to change these
                settings. Please only make changes if you know how this affects
                what customers can return.
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <h4
                  data-intercom-target="set-customer-return-type-title-configuration-returns"
                  style={{ marginBottom: 20 }}
                >
                  Set customer return type
                </h4>
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ gridRowGap: 20 }}
                >
                  <FormItem
                    name="allowOrderUnfulfilled"
                    valuePropName="checked"
                    initialValue={this.state.allowOrderUnfulfilled}
                  >
                    <Checkbox
                      data-intercom-target="allow-unfulfilled-checkbox-configuration-returns"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <div className="flex-row flex-row--noMargin u-rowGap--sm u-columnGap--sm flex-middle-xxs">
                        <div>Allow Returns for Unfulfilled Orders</div>
                        <Tooltip
                          data-intercom-target="allow-unfulfilled-info-icon-configuration-returns"
                          title="Example: a merchant wants customers to be able to return an order as a quasi cancellation for their order when the order itself has not shipped, yet. Note that we do not cancel the order, this has to be done manually."
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      </div>
                    </Checkbox>
                  </FormItem>
                  <FormItem
                    name="allowOrderPaymentPending"
                    valuePropName="checked"
                    initialValue={this.state.allowOrderPaymentPending}
                  >
                    <Checkbox
                      data-intercom-target="pending-payments-checkbox-configuration-returns"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <div className="flex-row flex-row--noMargin u-rowGap--sm u-columnGap--sm flex-middle-xxs">
                        <div>Allow Returns for Pending Payments</div>
                        <Tooltip
                          data-intercom-target="pending-payments-info-icon-configuration-returns"
                          title="Example: a merchant wants customers to be able to return an order when payment is settled in cash (e.g. courier) and there is a time delay in registering the transaction (manually) so the customer can already initiate a return."
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      </div>
                    </Checkbox>
                  </FormItem>
                  <FormItem
                    name="allowOrderPaymentAuthorized"
                    valuePropName="checked"
                    initialValue={this.state.allowOrderPaymentAuthorized}
                  >
                    <Checkbox
                      data-intercom-target="authorized-payments-checkbox-configuration-returns"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <div className="flex-row flex-row--noMargin u-rowGap--sm u-columnGap--sm flex-middle-xxs">
                        <div>Allow Returns for Authorized Payments</div>
                        <Tooltip
                          data-intercom-target="authorized-payments-info-icon-configuration-returns"
                          title="Example: a merchant wants customers to be able to return an order when payment has been authorized on the customer's end but not captured on the merchant's end. A payment usually goes instantly from authorized to paid in Shopify."
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      </div>
                    </Checkbox>
                  </FormItem>
                  <FormItem
                    name="allowMultipleReturns"
                    valuePropName="checked"
                    initialValue={this.state.allowMultipleReturns}
                  >
                    <Checkbox
                      data-intercom-target="multiple-returns-checkbox-configuration-returns"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <div className="flex-row flex-row--noMargin u-rowGap--sm u-columnGap--sm flex-middle-xxs">
                        <div>Allow multiple Returns</div>
                        <Tooltip
                          data-intercom-target="multiple-returns-info-icon-configuration-returns"
                          title="Example: you offer a lifetime warranty for your products to your customers. A customer has already received an exchange for a faulty item but a year later something else breaks and they need to initiate another Return. This will apply to all items in the order."
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      </div>
                    </Checkbox>
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          {!this.state.allScopesIncluded ? (
            <React.Fragment>
              <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                <div className="flex-col-md-3 flex-col-xxs-12">
                  <h4 data-intercom-target="enable-store-credit-title-configuration-returns">
                    Enable Gift Card or Discount Code
                  </h4>
                  <span>
                    When enabling this option, you will be redirected to Shopify
                    to configure your store credit either by a gift card or
                    discount code.
                  </span>
                </div>
                <div className="flex-col-md-8 flex-col-xxs-12">
                  <div className="ContentPanel">
                    <div className="flex-row flex-row--noMargin">
                      <FormItem>
                        <Button
                          ghost
                          data-intercom-target="enable-store-credit-button-configuration-returns"
                          href={this.state.shopifyUrl}
                        >
                          Enable scopes
                        </Button>
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {(this.state.shopifyPlanName === 'enterprise' ||
                this.state.shopifyPlanName === 'shopify_plus') && (
                <React.Fragment>
                  <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                    <div className="flex-col-md-3 flex-col-xxs-12">
                      <h4 data-intercom-target="enable-feature-gift-card-title-configuration-returns">
                        Enable feature gift card
                      </h4>
                    </div>
                    <div className="flex-col-md-8 flex-col-xxs-12">
                      <div className="ContentPanel">
                        <div className="flex-row flex-row--noMargin">
                          <FormItem
                            name="useGiftApiForStoreCredit"
                            valuePropName="checked"
                            initialValue={this.state.useGiftApiForStoreCredit}
                          >
                            <Checkbox
                              data-intercom-target="enable-feature-gift-card-checkbox-configuration-returns"
                              onChange={(e) => this.handleChange(e)}
                            >
                              Enable
                            </Checkbox>
                          </FormItem>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
              <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                <div className="flex-col-md-3 flex-col-xxs-12">
                  <h4 data-intercom-target="enable-feature-discount-code-title-configuration-returns">
                    Enable feature discount code
                  </h4>
                  <span>
                    To be able to send discount codes through Rich Returns, you
                    will need to enable the scopes in your Shopify dashboard.
                    Once the scopes are enabled, and this feature is activated
                    by checking the box, you will see a new button appear in the
                    Manage section where you can issue discount codes to your
                    customers.
                  </span>
                </div>
                <div className="flex-col-md-8 flex-col-xxs-12">
                  <div className="ContentPanel">
                    <div className="flex-row flex-row--noMargin">
                      <FormItem
                        name="useDiscountCodeForStoreCredit"
                        valuePropName="checked"
                        initialValue={this.state.useDiscountCodeForStoreCredit}
                      >
                        <Checkbox
                          data-intercom-target="enable-feature-discount-code-checkbox-configuration-returns"
                          onChange={(e) => this.handleChange(e)}
                        >
                          Enable
                        </Checkbox>
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          <Divider></Divider>

          {!this.state.storeCreditIncluded ? (
            <React.Fragment>
              <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                <div className="flex-col-md-3 flex-col-xxs-12">
                  <h4 data-intercom-target="enable-store-credit-included-title-configuration-returns">
                    Enable store credit
                  </h4>
                  <span>
                    To be able to issue Store Credit to your customers'
                    accounts, you need to Enable Scopes in Shopify. This button
                    will redirect you to Shopify to enable scopes. You will be
                    able to issue store credit through Rich Returns. You can
                    also{' '}
                    <a
                      data-intercom-target="store-credit-guide-link-configuration-returns"
                      href="https://support.richreturns.io/en/articles/17693644-how-can-i-enable-integrated-store-credit?utm_source=configuration-returns"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong>read our guide </strong>
                    </a>{' '}
                    for more information.
                  </span>
                </div>
                <div className="flex-col-md-8 flex-col-xxs-12">
                  <div className="ContentPanel">
                    <div className="flex-row flex-row--noMargin">
                      <FormItem>
                        <Button
                          ghost
                          data-intercom-target="enable-store-credit-included-button-configuration-returns"
                          href={this.state.storeCreditShopifyUrl}
                        >
                          Enable scopes
                        </Button>
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                <div className="flex-col-md-3 flex-col-xxs-12">
                  <h4 data-intercom-target="enable-feature-store-credit-title-configuration-returns">
                    Enable feature store credit
                  </h4>
                  <span>
                    <strong>IMPORTANT: </strong> To allow your customers to see
                    and spend store credit, the Store credit option in your
                    Shopify dashboard should be enabled. You can enable it here:{' '}
                    <a
                      href={
                        this.context.storeShopifyUrl +
                        '/admin/settings/customer_accounts'
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Store Credit.
                    </a>
                  </span>
                </div>
                <div className="flex-col-md-8 flex-col-xxs-12">
                  <div className="ContentPanel">
                    <div className="flex-row flex-row--noMargin">
                      <FormItem
                        name="useStoreCredit"
                        valuePropName="checked"
                        initialValue={this.state.useStoreCredit}
                      >
                        <Checkbox
                          data-intercom-target="enable-feature-store-credit-checkbox-configuration-returns"
                          onChange={(e) => this.handleChange(e)}
                        >
                          Enable
                        </Checkbox>
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          <Divider></Divider>

          {this.context.featureCustomerPhotoUpload ? (
            <React.Fragment>
              <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                <div className="flex-col-md-3 flex-col-xxs-12">
                  <h4 data-intercom-target="customer-photo-uploads-title-configuration-returns">
                    Customer media uploads
                  </h4>
                  <span>
                    Let customers upload photos/videos of their return-items.
                    You can review the photos/videos under the{' '}
                    <a href="/dashboard/returns">Returns</a> tab by selecting
                    one of the returns.
                  </span>
                </div>
                <div className="flex-col-md-8 flex-col-xxs-12">
                  <div className="ContentPanel">
                    <div
                      className="flex-row flex-row--noMargin"
                      style={{ gridRowGap: 20 }}
                    >
                      <FormItem
                        name="customerPhotoUploadEnabled"
                        valuePropName="checked"
                        initialValue={this.state.customerPhotoUploadEnabled}
                      >
                        <Checkbox
                          data-intercom-target="customer-photo-uploads-checkbox-configuration-returns"
                          onChange={(e) => this.handleChange(e)}
                        >
                          Enable
                        </Checkbox>
                      </FormItem>
                      <div
                        className="flex-row flex-row--noMargin u-width--100"
                        style={{ gap: 24 }}
                      >
                        <div>
                          <h4 style={{ marginBottom: 8 }}>Min media</h4>
                          <InputNumber
                            min={0}
                            max={this.state.maximumPhoto}
                            value={this.state.minimumPhoto}
                            onChange={this.handleMinPhotoChange}
                          />
                        </div>
                        <div>
                          <h4 style={{ marginBottom: 8 }}>Max media</h4>
                          <InputNumber
                            min={1}
                            max={5}
                            value={this.state.maximumPhoto}
                            onChange={this.handleMaxPhotoChange}
                          />
                        </div>
                      </div>
                      <FormItem
                        label="Description text"
                        name="customerPhotoUploadDescription"
                        initialValue={this.state.customerPhotoUploadDescription}
                      >
                        <TextArea
                          data-intercom-target="customer-photo-uploads-description-textarea-configuration-returns"
                          rows={6}
                          placeholder="This description will be displayed to customers alongside the photo/video upload. Briefly describe what they should pay attention to when uploading photos/videos."
                        />
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>
              <Divider></Divider>
            </React.Fragment>
          ) : null}

          {this.context.featureMultichannel ? (
            <React.Fragment>
              <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                <div className="flex-col-md-3 flex-col-xxs-12">
                  <h4 data-intercom-target="manual-multichannel-rmas-title-configuration-returns">
                    Manual Multichannel RMAs
                  </h4>
                </div>
                <div className="flex-col-md-8 flex-col-xxs-12">
                  <div className="ContentPanel">
                    <div
                      className="flex-row flex-row--noMargin"
                      style={{ gridRowGap: 20 }}
                    >
                      <h4 data-intercom-target="vendors-title-configuration-returns">
                        Vendors
                      </h4>
                      <span>
                        Add returns from vendors outside of Shopify. Enter as
                        many vendors as you like. One vendor per line (no comma
                        inbetween).
                      </span>
                      <FormItem
                        name="vendorList"
                        initialValue={this.state.vendorList}
                      >
                        <TextArea
                          data-intercom-target="vendor-list-textarea-configuration-returns"
                          rows={6}
                          placeholder="Enter 1 vendor per line (no comma inbetween)"
                        />
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>
              <Divider></Divider>
            </React.Fragment>
          ) : null}

          <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
            <div className="flex-col-md-3 flex-col-xxs-12">
              <h4 data-intercom-target="return-address-title-configuration-returns">
                Return address
              </h4>
              <span>
                Enter the address that is shown to customers in preparation for
                sending back their package. This address will also be used if
                you have pre-paid return-labels enabled above.
              </span>
            </div>
            <div className="flex-col-md-8 flex-col-xxs-12">
              <div className="ContentPanel">
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ gridRowGap: 20 }}
                >
                  <div className="u-width--100">
                    <h4 data-intercom-target="select-country-title-configuration-returns">
                      Select country
                    </h4>
                    <FormItem
                      name="receiverCountry"
                      initialValue={this.state.receiverCountry}
                      rules={[
                        { required: true, message: 'Please select country' },
                      ]}
                    >
                      <Select
                        data-intercom-target="receiver-country-select-configuration-returns"
                        placeholder="Select country"
                      >
                        {this.getCountriesList()}
                      </Select>
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="customer-name-title-configuration-returns">
                      Customer name
                    </h4>
                    <FormItem
                      name="receiverName"
                      initialValue={this.state.receiverName}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter customer name',
                        },
                      ]}
                    >
                      <Input data-intercom-target="receiver-name-input-configuration-returns" />
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="company-name-title-configuration-returns">
                      Company name
                    </h4>
                    <FormItem
                      name="receiverCompany"
                      initialValue={this.state.receiverCompany}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter company name',
                        },
                      ]}
                    >
                      <Input
                        data-intercom-target="receiver-company-input-configuration-returns"
                        placeholder="Company Name"
                      />
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="street-address-title-configuration-returns">
                      Street address
                    </h4>
                    <FormItem
                      name="receiverStreet1"
                      initialValue={this.state.receiverStreet1}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter street address',
                        },
                      ]}
                    >
                      <Input
                        data-intercom-target="receiver-street1-input-configuration-returns"
                        placeholder="Street and number, P.O. box, c/o."
                      />
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="apartment-suite-title-configuration-returns">
                      Apartment, suite, unit, building, floor, etc.
                    </h4>
                    <FormItem
                      name="receiverStreet2"
                      initialValue={this.state.receiverStreet2}
                    >
                      <Input
                        data-intercom-target="receiver-street2-input-configuration-returns"
                        placeholder="Apartment, suite, unit, building, floor, etc."
                      />
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="city-title-configuration-returns">
                      City
                    </h4>
                    <FormItem
                      name="receiverCity"
                      initialValue={this.state.receiverCity}
                      rules={[{ required: true, message: 'Please enter city' }]}
                    >
                      <Input
                        data-intercom-target="receiver-city-input-configuration-returns"
                        placeholder="City"
                      />
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="state-title-configuration-returns">
                      State
                    </h4>
                    <FormItem
                      name="receiverState"
                      initialValue={this.state.receiverState}
                      rules={[{ validator: this.handleStateValidator }]}
                    >
                      <Input
                        data-intercom-target="receiver-state-input-configuration-returns"
                        placeholder="State / Province / Region"
                      />
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="zip-code-title-configuration-returns">
                      Zip Code
                    </h4>
                    <FormItem
                      name="receiverZip"
                      initialValue={this.state.receiverZip}
                      rules={[
                        { required: true, message: 'Please enter zip code' },
                      ]}
                    >
                      <Input
                        data-intercom-target="receiver-zip-input-configuration-returns"
                        placeholder="Zip Code"
                      />
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="phone-number-title-configuration-returns">
                      Phone number
                    </h4>
                    <FormItem
                      name="receiverPhone"
                      initialValue={this.state.receiverPhone}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter phone number',
                        },
                      ]}
                    >
                      <Input
                        data-intercom-target="receiver-phone-input-configuration-returns"
                        placeholder="May be used to assist delivery"
                      />
                    </FormItem>
                  </div>
                  <div className="u-width--100">
                    <h4 data-intercom-target="email-title-configuration-returns">
                      E-Mail
                    </h4>
                    <FormItem
                      name="receiverEmail"
                      initialValue={this.state.receiverEmail}
                      rules={[
                        { required: true, message: 'Please enter email' },
                      ]}
                    >
                      <Input
                        data-intercom-target="receiver-email-input-configuration-returns"
                        placeholder="May be used to assist delivery"
                      />
                    </FormItem>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>

          {this.context.featureMultipleAddress && (
            <React.Fragment>
              <div className="flex-row flex-top-xxs flex-between-xxs u-rowGap--sm">
                <div className="flex-col-md-3 flex-col-xxs-12">
                  <h4 data-intercom-target="multiple-address-title-configuration-returns">
                    Multiple Addresses
                  </h4>
                </div>
                <div className="flex-col-md-8 flex-col-xxs-12">
                  <div className="ContentPanel">
                    <div className="flex-row flex-row--noMargin">
                      <h4 data-intercom-target="store-address-title-configuration-returns">
                        Store Address
                      </h4>
                      <p className="u-marginBottom--md">
                        You can add multiple store addresses. Selected Store
                        address that is shown to customers in preparation for
                        sending back their package. This address will also be
                        used if you have pre-paid return-labels enabled above
                      </p>
                      <ReturnMultipleAddress
                        data-intercom-target="return-multiple-address-component-configuration-returns"
                        countriesList={this.getCountriesList()}
                        handleChangeMultipleAddress={
                          this.handleChangeMultipleAddress
                        }
                        defaultActiveStoreAddress={
                          this.state.selectedStoreAddress
                        }
                        showAddressModal={this.showAddressModal}
                        visible={this.state.visible}
                        getReturnSettings={this.getReturnSettings}
                        updateProps={this.state.updateProps}
                      />
                      <div className="u-width--100 u-marginTop--md">
                        {this.context.featureMultipleAddressQuota > 0 ? (
                          <Text data-intercom-target="multiple-address-quota-text-configuration-returns">
                            You have {this.context.featureMultipleAddressQuota}{' '}
                            store addresses left on your current plan.{' '}
                          </Text>
                        ) : (
                          <p>
                            <Text data-intercom-target="multiple-address-quota-text-configuration-returns">
                              You have{' '}
                              {this.context.featureMultipleAddressQuota} store
                              addresses left on your current plan. Upgrade your
                              plan.
                            </Text>
                          </p>
                        )}
                      </div>
                      <Button
                        ghost
                        data-intercom-target="add-multiple-address-button-configuration-returns"
                        onClick={this.showAddressModal}
                        disabled={
                          this.context.featureMultipleAddressQuota === 0
                            ? true
                            : false
                        }
                        className="u-marginTop--md"
                      >
                        Add Multiple Addresses
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}

          <div className="flex-row flex-row--noMargin flex-end-xxs u-marginBottom--md u-marginTop--sm">
            <FormItem>
              <Button
                type="primary"
                htmlType="submit"
                data-intercom-target="bottom-save-button-configuration-returns"
              >
                Save changes
              </Button>
            </FormItem>
          </div>
        </Form>
      </React.Fragment>
    );
  }
}

export default Settings;
